/**
 * Password Toggle
 *
 * Ergänzt Passwortfelder um einen Schalter zum Ein- und Ausblenden
 * der eingegebenen Zeichen (Login, Registrierung, Passwort ändern).
 *
 * @version     1.0.0
 * @author      Erwin Müller Versandhaus GmbH
 */

(function (window, document) {
  var LABELS = {
    show: 'Passwort anzeigen',
    hide: 'Passwort verbergen',
    stateOn: 'Passwort wird angezeigt',
    stateOff: 'Passwort wird verborgen'
  };

  function readLabel(name, fallback) {
    var value = document.body && document.body.getAttribute('data-pw-' + name);
    return value && value.trim() ? value.trim() : fallback;
  }

  function labels() {
    return {
      show: readLabel('show', LABELS.show),
      hide: readLabel('hide', LABELS.hide),
      stateOn: readLabel('state-on', LABELS.stateOn),
      stateOff: readLabel('state-off', LABELS.stateOff)
    };
  }

  function announce(message) {
    var live = document.getElementById('sr-status') || document.getElementById('sr-msg');
    if (!live) {
      return;
    }
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = message;
    }, 50);
  }

  function bindToggle(toggle, input) {
    var text = labels();

    if (!toggle.getAttribute('role')) {
      toggle.setAttribute('role', 'switch');
    }
    if (!toggle.hasAttribute('tabindex') && toggle.tagName !== 'BUTTON') {
      toggle.setAttribute('tabindex', '0');
    }
    if (!toggle.getAttribute('aria-label')) {
      toggle.setAttribute('aria-label', text.show);
    }
    toggle.setAttribute('aria-checked', toggle.getAttribute('aria-checked') || 'false');
    toggle.setAttribute('aria-pressed', toggle.getAttribute('aria-pressed') || 'false');

    if (toggle.dataset.passwordToggleBound === 'true') {
      return;
    }
    toggle.dataset.passwordToggleBound = 'true';

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      var visible = input.type === 'text';
      var showPlain = !visible;
      input.type = showPlain ? 'text' : 'password';
      toggle.setAttribute('aria-checked', showPlain ? 'true' : 'false');
      toggle.setAttribute('aria-pressed', showPlain ? 'true' : 'false');
      toggle.setAttribute('aria-label', showPlain ? text.hide : text.show);

      var icon = toggle.querySelector('i.fa, span.icon');
      if (icon && icon.classList.contains('fa')) {
        icon.classList.toggle('fa-eye', showPlain);
        icon.classList.toggle('fa-eye-slash', !showPlain);
      }

      announce(showPlain ? text.stateOn : text.stateOff);
    });

    toggle.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle.click();
      }
    });
  }

  function createToggleButton() {
    var text = labels();
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'js-password-toggle';
    button.setAttribute('role', 'switch');
    button.setAttribute('aria-checked', 'false');
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', text.show);
    button.innerHTML = '<i class="fa fa-eye-slash" aria-hidden="true"></i>';
    return button;
  }

  function enhanceInput(input) {
    var parent = input.parentElement;
    if (!parent) {
      return;
    }

    if (input.closest('.form-wrapper-em') || parent.querySelector('.input-append')) {
      return;
    }

    var existing = parent.querySelector('#togglePassword, .js-password-toggle');
    if (existing) {
      bindToggle(existing, input);
      return;
    }

    if (input.closest('.password-field-wrap')) {
      return;
    }

    var wrap = document.createElement('span');
    wrap.className = 'password-field-wrap';
    parent.insertBefore(wrap, input);
    wrap.appendChild(input);
    wrap.appendChild(createToggleButton());
    bindToggle(wrap.querySelector('.js-password-toggle'), input);
  }

  function initPasswordToggles() {
    var fields = document.querySelectorAll('input[type="password"]');
    for (var i = 0; i < fields.length; i++) {
      enhanceInput(fields[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPasswordToggles);
  } else {
    initPasswordToggles();
  }
})(window, document);
